module.exports = __webpack_public_path__ + "static/media/cbarlogo.787559b0.png";